import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class FilterTileRefreshService {
  constructor() {}

  public refreshFilterTile$ = new Subject<void>()

  triggerFilterTileRefresh() {
    this.refreshFilterTile$.next()
  }
}
